import { hasClass } from "../utils/_class-handlers";

function objectFit() {

    if ('objectFit' in document.documentElement.style === false) {
        var container = document.getElementsByClassName('object-fit');
    
        for (var i = 0; i < container.length; i++) {
            var imageSource = container[i].querySelector('img').src;
            if (hasClass(container[i], 'lazy-load-container')) {
                imageSource = container[i].querySelector('img').getAttribute('full');
            }
            container[i].querySelector('img').style.display = 'none';
            container[i].style.backgroundSize = 'cover';
            container[i].style.backgroundImage = 'url(' + imageSource + ')';
            container[i].style.backgroundPosition = 'center center';
            container[i].style.backgroundRepeat = 'no-repeat';
        }
    }
}

module.exports = {
    objectFit
};


// WEBPACK FOOTER //
// ./resources/js/utils/_object-fit.js